<template>
  <div :class="rootClass">
    <b-row>
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col lg="3" sm="12">
            <b-row align-v="center">
              <label :class="rootClass + '__phone-number-label'"
              >Số Serial Sim</label
              >
              <b-form-input
                  ref="inputSearchPhone"
                  v-model="searchPhone"
                  :class="rootClass + '__phone-number-input'"
                  type="number"
                  v-on:keyup.enter="getDkttHistory()"
              ></b-form-input>
            </b-row>
          </b-col>
          <b-col lg="2" sm="12" style="display: flex; align-items: center; max-width: 13%;margin-right: 4%">
            <b-button
                :class="rootClass + '__search-voice-sms-data-btn'"
                class="redButton"
                style="margin-left: -30%"
                variant="danger"
                @click="getDkttHistory()"
            >Tra cứu
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <table :class="rootClass + '__history-voice-sms-data-table'">
            <tr style="height: 3rem">
              <template v-for="(h, i) in historyDataTable.fields"
              >
                <th
                    :key="h.key"
                    :class="{
                          '--first-th': i === 0,
                          '--last-th':
                            i === historyDataTable.fields.length - 1,
                        }"
                >
                  {{ h.label }}
                </th>
              </template>
            </tr>
            <tr v-for="(i,index) in historyResult" v-if="showErrSearch===false " style="color:black;">
              <td>{{ index + 1 }}</td>
              <td @click="getC06History(i.IDNUMBER,i.MODIFYDATE,index)">
                <button class="btn btn-primary">
                  <file-text-icon size="1x"></file-text-icon>
                </button>
              </td>
              <td>{{ i.ID }}</td>
              <td>{{ i.MSISDN }}</td>
              <td style="min-width: 10rem;">{{ i.NAME }}</td>
              <td>{{ i.BIRTHDAY }}</td>
              <td style="min-width: 15rem">{{ i.ADDRESS }}</td>
              <td>{{ i.GENDER }}</td>
              <td>{{ i.PASSPORT }}</td>
              <td>{{ i.IDNUMBERTYPE }}</td>
              <td>{{ i.IDNUMBER }}</td>
              <td>{{ i.PLACEOFISSUE }}</td>
              <td>{{ i.PLACEDATE }}</td>
              <td>{{ i.COMPANY }}</td>
              <td>{{ i.JOB }}</td>
              <td>{{ i.EMAIL }}</td>
              <td>{{ i.NATIONALITYID }}</td>
              <td style="min-width: 10rem;">{{ i.NOTE }}</td>
              <td style="min-width: 12rem;">{{ i.REGISTERMETHODID }}</td>
              <td>{{ i.MODIFYDATE }}</td>
              <td>{{ i.REGISTERDATE }}</td>
              <td>{{ i.AS_NAME }}</td>
              <td style="min-width: 10rem;">{{ i.AGENTID }}</td>
              <td>{{ i.KENH }}</td>
              <td>{{ i.MIEN }}</td>
              <td>{{ i.PHAN_LOAI }}</td>
            </tr>
          </table>
        </b-row>
        <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
          Không tìm thấy kết quả!
        </b-row>
      </b-col>
    </b-row>
    <b-modal
        v-model="showC06HisModal"
        title="Lịch sử kiểm tra c06"
        size="xl"
        hide-footer
        @hidden="showC06HisModal=false"
    >
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead class="thead-primary">
          <tr>
            <th style="min-width: 60px;">STT</th>
            <th style="min-width: 80px;">ID</th>
            <th style="min-width: 150px;">Số CCCD</th>
            <th style="min-width: 120px;">Ngày sinh</th>
            <th style="min-width: 180px;">Họ tên đầy đủ</th>
            <th style="min-width: 100px;">KQ CCCD</th>
            <th style="min-width: 100px;">KQ Ngày sinh</th>
            <th style="min-width: 100px;">KQ Tên</th>
            <th style="min-width: 150px;">Thời gian kiểm tra</th>
          </tr>
          </thead>
          <tbody v-if="c06Info && c06Info.detail">
          <tr v-for="(item, index) in c06Info.detail" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.id }}</td>
            <td>{{ item.idnumber || 'N/A' }}</td>
            <td>{{ formatDob(item.dob) || 'N/A' }}</td>
            <td>{{ item.name || 'N/A' }}</td>
            <td class="text-center">
              <feather-icon
                  v-if="item.idnumber_result === 'true'"
                  icon="CheckIcon"
                  size="18"
                  class="text-success"
              />
              <feather-icon
                  v-else-if="item.idnumber_result === 'false'"
                  icon="XIcon"
                  size="18"
                  class="text-danger"
              />
              <span v-else class="text-muted">N/A</span>
            </td>
            <td class="text-center">
              <feather-icon
                  v-if="item.dob_result === 'true'"
                  icon="CheckIcon"
                  size="18"
                  class="text-success"
              />
              <feather-icon
                  v-else-if="item.dob_result === 'false'"
                  icon="XIcon"
                  size="18"
                  class="text-danger"
              />
              <span v-else class="text-muted">N/A</span>
            </td>
            <td class="text-center">
              <feather-icon
                  v-if="item.name_result === 'true'"
                  icon="CheckIcon"
                  size="18"
                  class="text-success"
              />
              <feather-icon
                  v-else-if="item.name_result === 'false'"
                  icon="XIcon"
                  size="18"
                  class="text-danger"
              />
              <span v-else class="text-muted">N/A</span>
            </td>
            <td>{{ formatDateTime(item.log_date) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment/moment";
import {FileTextIcon} from 'vue-feather-icons'

export default {
  name: "DkttHistory",
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BContainer,
    BFormDatepicker,
    DropMenu,
    FileTextIcon
  },
  data() {
    return {
      showC06HisModal: false,
      c06Info: null,
      rootClass: "search-crs",
      historyDataTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "ACTION", label: ""},
          {key: "ID", label: "ID"},
          {key: "PhoneNumber", label: "Số thuê bao"},
          {key: "Name", label: "Tên thuê bao"},
          {key: "BIRTHDAY", label: "Ngày sinh"},
          {key: "ADDRESS", label: "Địa chỉ"},
          {key: "GENDER", label: "Giới tính"},
          {key: "PASSPORT", label: "Số hộ chiếu"},
          {key: "IDNUMBERTYPE", label: "Loại giấy tờ"},
          {key: "IDNUMBER", label: "Số giấy tờ"},
          {key: "PLACEOFISSUE", label: "Nơi cấp"},
          {key: "PLACEDATE", label: "Ngày cấp"},
          {key: "COMPANY", label: "Công ty"},
          {key: "JOB", label: "Công việc"},
          {key: "EMAIL", label: "Email"},
          {key: "NATIONALITYID", label: "Quốc gia"},
          {key: "NOTE", label: "Ghi chú"},
          {key: "REGISTERMETHODID", label: "Hệ thống thực hiện"},
          {key: "MODIFYDATE", label: "Thời gian kích hoạt"},
          {key: "REGISTERDATE", label: "Ngày đăng kí"},
          {key: "AGENTID", label: "User thực hiện"},
          {key: "AGENTNAME", label: "Tên User thực hiện"},
          {key: "AGENTIDFIRST", label: "User thuộc kênh"},
          {key: "REGION", label: "Miền"},
          {key: "CUSTOMERTYPE", label: "Loại tập TB"},
        ]
      },
      CdrDetail: [],
      regex087: /87\d{7}$/,
      historyResult: "",
      showErrSearch: true,
      NumberTypeName: {45: "CCCD", 3: "Hộ chiếu", 1: "CMT"}
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    if (this.searchPhone.length > 0) {
      this.getDkttHistory();
    }
  },
  computed: {},
  methods: {
    formatDateTime(dateString) {
      if (!dateString) return 'N/A';
      try {
        return moment(dateString).format("DD/MM/YYYY HH:mm:ss");
      } catch (e) {
        return dateString;
      }
    },
    formatDob(dobString) {
      if (!dobString || dobString.length !== 8) {
        return dobString;
      }
      // Format từ "19760617" thành "17/06/1976"
      const year = dobString.substring(0, 4);
      const month = dobString.substring(4, 6);
      const day = dobString.substring(6, 8);
      return `${day}/${month}/${year}`;
    },
    formatPhoneNum() {
      if (this.searchPhone.startsWith("0")) {
        return this.searchPhone.replace("0", "84")
      }
      if (this.searchPhone.startsWith("84")) {
        return this.searchPhone
      }
      return this.searchPhone;
    },
    getDkttHistory() {
      this.showLoading("block")
      useJwt.get('get-dktt-history/' + this.searchPhone).then((response) => {
        this.showLoading("none")
        this.historyResult = response.data.result;
        this.showErrSearch = false
        if (this.historyResult.length > 0) {
          this.historyResult.forEach((e) => {
            e.NAME = (e.FIRSTNAME ? e.FIRSTNAME : "") + " " + (e.MIDDLENAME ? e.MIDDLENAME : "") + " " + (e.LASTNAME ? e.LASTNAME : "");
            e.BIRTHDAY = moment(e.BIRTHDAY).format("DD/MM/YYYY");
            e.PLACEDATE = moment(e.PLACEDATE).format("DD/MM/YYYY HH:mm:ss");
            e.REGISTERDATE = moment(e.REGISTERDATE).format("DD/MM/YYYY HH:mm:ss");
            e.MODIFYDATE = moment(e.MODIFYDATE).format("DD/MM/YYYY HH:mm:ss");
            if (e.GENDER === "female") {
              e.GENDER = "Nữ"
            } else {
              e.GENDER = "Nam"
            }
            e.IDNUMBERTYPE = this.NumberTypeName[e.IDNUMBERTYPE];
            if (e.NATIONALITYID === 232) {
              e.NATIONALITYID = "Việt Nam"
            } else {
              e.NATIONALITYID = "Khác"
            }
          })
        }
        console.log("msisdn", this.historyResult);
      }).catch((error) => {
        this.showLoading("none")
        this.historyResult = ""
        this.showErrSearch = true
        console.log(error);
      });
    },

    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
    getC06History(idNumber, modifyDate, rowIndex) {
      let formattedDate = modifyDate;
      try {
        // Nếu modifyDate có format DD/MM/YYYY HH:mm:ss
        if (modifyDate.includes('/')) {
          const datePart = modifyDate.split(' ')[0]; // Lấy phần date
          const [day, month, year] = datePart.split('/');
          formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
      } catch (e) {
        console.warn("Error formatting date:", e);
      }
      this.loading(true)
      useJwt.get(`c06/${idNumber}/${this.formatPhoneNum()}/${formattedDate}/${rowIndex + 1}`).then(response => {
        this.loading(false)
        this.c06Loading = false;
        if (response.data && response.data.code === 200 && response.data.result) {
          this.c06Info = response.data.result;
          this.showC06HisModal = true;
        } else {
          console.warn("C06 API warning:", response.data?.message || "Không lấy được thông tin C06");
          this.c06Info = null;
        }
      }).catch(error => {
        this.loading(false)
        this.c06Loading = false;
        console.error("C06 API error:", error);
        this.c06Info = null;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.search-crs {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__card {
    border-radius: 2rem;
    background: #fcfcfc;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-crs-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 16px;
    margin-right: 1rem;
    width: 100px;
  }

  &__phone-number-input {
    width: 200px;
    font-size: 16px;
  }

  &__from-date-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__from-date-input {
    width: 200px;
  }

  &__to-date-label {
    font-weight: 500;
    color: black;
    font-size: 12px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__to-date-input {
    width: 200px;
  }

  &__search-voice-sms-data-btn {
    border-radius: 40px;
    //font-size: 10px;
  }

  &__history-voice-sms-data-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    .clickableButton {
      cursor: pointer;
      color: #384DC0;
      text-decoration: underline;
    }

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      padding: 0 0.5rem 0 0.5rem;
      min-width: 7rem;
    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__export-voice-sms-data-btn {
    border-radius: 40px;
  }

  &__search-spam-btn {
    border-radius: 40px;
    font-size: 10px;
  }

  &__history-spam-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border-right: 0.299185px solid rgba(184, 184, 184, 0.5);
      border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      color: black;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__menu-right-group {
    position: absolute;
    top: 60px;
    right: 20px;
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .search-crs {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__from-date-label {
      width: 100%;
    }

    &__from-date-input {
      width: 100%;
    }

    &__to-date-label {
      width: 100%;
    }

    &__to-date-input {
      width: 100%;
    }
  }
}
</style>
